import { render } from "./2_Windzone.vue?vue&type=template&id=8bdb3a5e"
import script from "./2_Windzone.vue?vue&type=script&lang=js"
export * from "./2_Windzone.vue?vue&type=script&lang=js"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__